import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote, TrendingUp, Users, Target } from "lucide-react";

const WebsiteDesignTestimonials = () => {
  const testimonials = [
    {
      name: "James Mitchell",
      company: "Mitchell & Co. Consulting",
      location: "London, UK",
      quote: "Our old website was getting 200 visitors a month with zero conversions. After the redesign, we now get 3,500+ monthly visitors and generate 15-20 qualified leads per month. The ROI has been incredible.",
      metrics: [
        { label: "Traffic Increase", value: "1,650%", icon: TrendingUp },
        { label: "Monthly Leads", value: "15-20", icon: Target },
      ],
      avatar: "JM"
    },
    {
      name: "Emma Richardson",
      company: "Richardson Legal Services",
      location: "Manchester, UK", 
      quote: "We were hesitant about the investment, but our new website paid for itself in the first month. Conversion rate went from 0.8% to 4.2%, and we're now booking consultations daily instead of weekly.",
      metrics: [
        { label: "Conversion Rate", value: "4.2%", icon: Target },
        { label: "ROI Timeline", value: "30 days", icon: TrendingUp },
      ],
      avatar: "ER"
    },
    {
      name: "David Thompson",
      company: "Thompson Property Group",
      location: "Birmingham, UK",
      quote: "The difference is night and day. Our bounce rate dropped from 72% to 28%, and we're generating £50K+ in additional revenue per month from online inquiries. Best business investment we've made.",
      metrics: [
        { label: "Bounce Rate", value: "-61%", icon: Users },
        { label: "Monthly Revenue", value: "+£50K", icon: TrendingUp },
      ],
      avatar: "DT"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Real Results from <span className="text-secondary">Real Clients</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See how our website designs transformed businesses with measurable growth in traffic, 
            conversions, and revenue.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-luxury hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-card/95 backdrop-blur-sm relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-secondary to-primary"></div>
              <CardContent className="p-8">
                <div className="flex items-center justify-between mb-6">
                  <Quote className="w-8 h-8 text-secondary opacity-50" />
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-secondary text-secondary" />
                    ))}
                  </div>
                </div>
                
                <p className="text-muted-foreground mb-6 leading-relaxed italic">
                  "{testimonial.quote}"
                </p>

                <div className="border-t border-border pt-6">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-secondary to-primary rounded-full flex items-center justify-center">
                      <span className="text-primary-foreground font-semibold text-sm">
                        {testimonial.avatar}
                      </span>
                    </div>
                    <div>
                      <div className="font-semibold text-foreground">{testimonial.name}</div>
                      <div className="text-sm text-muted-foreground">{testimonial.company}</div>
                      <div className="text-xs text-muted-foreground">{testimonial.location}</div>
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    {testimonial.metrics.map((metric, idx) => (
                      <div key={idx} className="flex items-center justify-between p-3 bg-primary/10 rounded-lg border border-primary/20">
                        <div className="flex items-center gap-2">
                          <metric.icon className="w-4 h-4 text-primary" />
                          <span className="text-sm text-foreground font-medium">{metric.label}</span>
                        </div>
                        <span className="text-sm font-bold text-primary">{metric.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebsiteDesignTestimonials;
